import React from 'react';

const ProfileModal = ({
  isOpen,
  onClose,
  user,
  subscriptionData,
  profilePasswordForm,
  setProfilePasswordForm,
  handleChangePassword,
  isChangingPassword,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-slate-900/60 backdrop-blur-xs flex items-center justify-center p-4">
      <div className="fixed inset-0" onClick={onClose} />
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden z-10 animate-fadeIn text-slate-800">
        <div className="p-4 px-5 border-b border-slate-100 bg-blue-600 text-white flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <div className="w-8 h-8 rounded-xl bg-white/20 text-white flex items-center justify-center">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <div>
              <h3 className="text-base font-bold text-white">Profile & Security</h3>
              <p className="text-[11px] text-blue-100">User account & credential settings</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center text-xs"
          >
            ✕
          </button>
        </div>

        <div className="p-5 space-y-4 text-xs">
          {/* User Identity Info */}
          <div className="p-3.5 rounded-xl bg-slate-50 border border-slate-200/80 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-slate-500 font-semibold">Username:</span>
              <span className="font-bold text-slate-900">{user?.username || 'Admin'}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-500 font-semibold">Email:</span>
              <span className="font-bold text-slate-900">
                {user?.email || subscriptionData?.contact_email || 'ajay@nexius.in'}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-500 font-semibold">Role:</span>
              <span className="bg-blue-50 text-blue-700 border border-blue-200 px-2 py-0.5 rounded font-bold uppercase text-[10px]">
                {(user?.role || 'Admin').toUpperCase()}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-slate-500 font-semibold">Organization:</span>
              <span className="font-bold text-slate-900">
                {user?.client_name || subscriptionData?.organization_name || 'Nexius'}
              </span>
            </div>
          </div>

          {/* Change Password Form (Hidden for SuperAdmin) */}
          {user?.role !== 'superadmin' ? (
            <form onSubmit={handleChangePassword} className="space-y-3 pt-2 border-t border-slate-100">
              <h4 className="font-bold text-slate-900 text-xs uppercase tracking-wider">Change Account Password</h4>
              <div>
                <label className="block text-[11px] font-semibold text-slate-600 mb-1">Current Password</label>
                <input
                  type="password"
                  required
                  placeholder="••••••••"
                  className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2 text-slate-800 focus:outline-none"
                  value={profilePasswordForm.current_password}
                  onChange={(e) =>
                    setProfilePasswordForm({ ...profilePasswordForm, current_password: e.target.value })
                  }
                />
              </div>
              <div>
                <label className="block text-[11px] font-semibold text-slate-600 mb-1">New Password (min 6 characters)</label>
                <input
                  type="password"
                  required
                  minLength={6}
                  placeholder="••••••••"
                  className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2 text-slate-800 focus:outline-none"
                  value={profilePasswordForm.new_password}
                  onChange={(e) =>
                    setProfilePasswordForm({ ...profilePasswordForm, new_password: e.target.value })
                  }
                />
              </div>
              <div>
                <label className="block text-[11px] font-semibold text-slate-600 mb-1">Confirm New Password</label>
                <input
                  type="password"
                  required
                  minLength={6}
                  placeholder="••••••••"
                  className="w-full bg-slate-50 border border-slate-200 focus:bg-white focus:border-blue-500 rounded-xl p-2 text-slate-800 focus:outline-none"
                  value={profilePasswordForm.confirm_password}
                  onChange={(e) =>
                    setProfilePasswordForm({ ...profilePasswordForm, confirm_password: e.target.value })
                  }
                />
              </div>
              <button
                type="submit"
                disabled={isChangingPassword}
                className="w-full py-2 px-4 rounded-xl bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-bold shadow-xs disabled:opacity-50 transition-all text-xs"
              >
                {isChangingPassword ? 'Updating Password...' : 'Update Password'}
              </button>
            </form>
          ) : (
            <div className="pt-2 border-t border-slate-100 flex justify-end">
              <button
                type="button"
                onClick={onClose}
                className="w-full py-2 px-4 rounded-xl bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold transition-all text-xs cursor-pointer"
              >
                Close
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;
